module.exports = __webpack_public_path__ + "img/img13.d65cb746.jpg";